import React, { memo } from 'react';
import './Filters.css';
import MultipleSelect from './MultipleSelect';
import useLocations from './hooks/useLocations';
import { useFiltersContext } from './hooks/useFiltersContext';
import { getMonthsByYear } from '../Util/getMonthsByYear';
import { getYearsDescending } from '../Util/getYearsDescending';
import Toast from '../../../Util/Toast/Toast';
import PDFGeneratorButton from './PDF/PDFGeneratorButton';

export const years = getYearsDescending();

const Filters = ({ className = '' }) => {
    const { data, isLoading } = useLocations();
    const { handleChangeFilters, filters } =
        useFiltersContext();

    const onFilterChange = (name, value) => {
        const newFilters = { ...filters, [name]: value };
        handleChangeFilters(newFilters);
    };

    const locations = data || [];

    if (locations.length === 0 && !isLoading) {
        Toast.error('Não existem unidades de saúde cadastradas');
    }

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Unidade de Saúde"
                options={[
                    {
                        value: locations
                            .map((location) => location.co_cnes)
                            .join(','),
                        label: 'Todos'
                    },
                    ...locations.map((location) => ({
                        value: location.co_cnes,
                        label: location.no_fantasia
                    }))
                ]}
                onChange={onFilterChange}
                name="unidade"
                className="select-unidade-dashboards"
                defaultValue={filters.unidade}
            />
            <MultipleSelect
                label="Ano"
                options={[
                    ...years
                        .map((year) => ({ value: year, label: year }))
                        .reverse()
                ]}
                onChange={onFilterChange}
                name="ano"
                defaultValue={filters.ano}
                className="select-ano-dashboards"
            />
            <MultipleSelect
                label="Competência"
                options={[
                    { value: '', label: 'Todos' },
                    ...getMonthsByYear(filters.ano.value).map(
                        (month, index) => ({
                            value: `${index + 1}`.padStart(2, '0'),
                            label: month
                        })
                    )
                ]}
                onChange={onFilterChange}
                name="competencia"
                defaultValue={filters.competencia}
                className="select-competencia-dashboards"
            />

        </div>
    );
};

export default memo(Filters);
